import { graphql } from '../../graphql/generated';

export const PARAMETER_SELECTION_QUERY = graphql(`
  query ParameterSelection(
    $patientData: PatientDataInput!
    $doctorId: ID!
    $mainDoctorId: ID!
    $requestIdForReorder: ID
  ) {
    requestableParameters(patientData: $patientData, doctorId: $doctorId, requestIdForReorder: $requestIdForReorder) {
      ...ParameterSelection_RequestableParameter
    }

    insurances {
      id
      code
      shortName
    }

    profiles(doctorId: $mainDoctorId) {
      ...ParameterSelection_Profile
    }

    doctorSheets(doctorId: $mainDoctorId, withLabSheets: true) {
      ...ParameterSelection_DoctorSheet
    }

    doctor(id: $mainDoctorId) {
      id
      showPriceSuggestion
      patientBilling
      flipParamNames
      showPrices
      overrideRequestEnabled
      aiEnabled
    }
  }
`);

export const RequestableParameterFragment = graphql(`
  fragment ParameterSelection_RequestableParameter on RequestableParameter {
    id
    mainParameterId
    shortName
    longName
    withoutParameterIds
    withoutParameterNames
    withParameterNames
    billingInfos {
      billingType
      price
      text
      additionalText
      specialRateId
      diagnoseId
    }
    pricePatient
    specimens {
      id
      classification
      name
      storagePeriod
      requiresLocalizations
      localizationInputEnabled
      predefinedLocalizations
      localizationFields {
        label
        inputType
        unit
        mandatory
      }
      testTubes {
        id
        color
        name
        hasImage
        labelText
        labelText2
        link
        volume
        specialPrinterRequired
      }
    }
    lab {
      id
      name
      shortName
      identifier
      aiEnabled
    }
    link
    description
    billingDescription
    importantDescription
    evalHours
    synonyms
    acute
    volume
  }
`);

export const ProfileFragment = graphql(`
  fragment ParameterSelection_Profile on Profile {
    id
    name
    hotKey
    parameters {
      id
      parameter {
        id
        shortName
        longName
        acute
        lab {
          id
          shortName
        }
      }
      preferredBillingType
    }
    diagnose
    diagnoses {
      id
      name
    }
  }
`);

export const DoctorSheetFragment = graphql(`
  fragment ParameterSelection_DoctorSheet on Sheet {
    id
    doctorId
    labId
    lab {
      id
      name
    }
    data
  }
`);

export const OPEN_REQUESTS_BY_SVNR_QUERY = graphql(`
  query OpenRequestsBySvnr($doctorId: ID!, $svnr: String!) {
    openRequests(doctorId: $doctorId, svnr: $svnr) {
      id
      aisVendor
      ...OpenRequestsBySvnrModal_Request
    }
  }
`);

export const PATIENT_REQUESTS_QUERY = graphql(`
  query QueryParameterSelectionPatientRequests($doctorId: ID!, $svnr: String!) {
    patientRequests(doctorId: $doctorId, svnr: $svnr) {
      id
      reorderable
    }
  }
`);

export const ADD_PARAMETERS_MUTATION = graphql(`
  mutation AddParameters($input: AddParametersInput!) {
    addParameters(input: $input) {
      incompatibleParams
      paramsToAdd {
        parameterId
        billingInfo {
          billingType
          price
          text
          additionalText
          specialRateId
          diagnoseId
        }
      }
    }
  }
`);
